import { makeProxyRequest } from "../api";

export const fetchReferrals = async (authUserId: string) => {
  const endpoint = `api/memeverse/referral_data?user_id=${authUserId}`;
  return makeProxyRequest(endpoint, 'GET', undefined, authUserId);
}

export const sendReferralEmail = async (
  authUserId: string,
  targetEmail: string,
) => {
  const data = {
    user_id: authUserId,
    email: targetEmail,
  };

  return makeProxyRequest('api/memeverse/send_referral_email', 'POST', data, authUserId);
}

// Helper functions
export const isValidEmail: (email: string) => boolean = (email: string) => {
  return !!email && !!(email.toLowerCase()
  .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ));
}

export const handleSendReferralEmail = async (
  authUser: any,
  email: string,
  refetch: any,
  toast: any,
  inputRef?: any
) => {
  if (isValidEmail(email)) {
    return sendReferralEmail(authUser.uid, email)
    .then((resp) => {
      if (resp.ok) {
        if (toast) toast.success("Invite sent successfully")
        if (refetch) refetch()
        if (inputRef) inputRef.current.value = '';
      } else {
        if (toast) toast.error("Error sending invite")
      }
    }
    ).catch((error) => {
      console.log(error)
      if (toast) toast.error("Error sending invite")
    })
  }
}
